/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";
import Axios from "axios";
import { TokenStorage } from "../../storage";


const ApplicationService = {
    async getAPIVersion() {
        ApiService.init(appConfig.VUE_APP_ROOT_API);
        const requestScreenData = {
            url: "api/Version",
        };

        return await ApiService.oDataGet(requestScreenData);
    },

    async getUIVersion(baseurl) {
        // ApiService.init(baseurl);
        // const requestScreenData = {
        //     url: "index.html",
        // };

        // return await ApiService.oDataGet(requestScreenData);

        if(appConfig.VUE_APP_BASE_URL != "/") {
            baseurl = baseurl + "/" + appConfig.VUE_APP_BASE_URL;
        }

        const axiosInstance = Axios.create({
            baseURL: baseurl, // Set your base URL
            headers: {
                'Content-Type': 'application/json', // Example default header
                'Authorization': `Bearer ${TokenStorage.getToken()}`, // Example default authorization header
                "x-tenant-id": TokenStorage.getTenant()
            },
        });

        return axiosInstance.get('index.html')
            .then(response => {
                return response;
            })
            .catch(error => {
                return error;
            });
    }
};

export { ApplicationService };
